module.exports = __webpack_public_path__ + "img/h3.c35740ec.png";